export class ColorForBarChart {
    static count = 1;

    static Refresh() {
        this.count = 1
    }

    static GetColor() {
        switch (this.count) {
            case 1:
                this.count++
                return "#8884d8"
            case 2:
                this.count++
                return "#ff5050"
            case 3:
                this.count++
                return "#5eff1a"
            case 4:
                this.count++
                return "#1fecff"
            case 5:
                this.count++
                return "#f100ff"
            default:
                return "#f6ff06"
        }
    }
}
